import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { ParamsGuard } from '@utils/guards/params.guard';
import { PaymentFlowComponent } from './domain/payment-domain/ui-commons/payment-flow/payment-flow.component';
import {
  PageErrorGlobalComponent
} from './domain/payment-domain/ui-commons/page-error-global/page-error-global.component';
import {
  PageOutScheduleComponent
} from './domain/payment-domain/ui-commons/page-out-schedule/page-out-schedule.component';
import {
  PageTransferResumeComponent
} from "./domain/payment-domain/ui-commons/page-transfer-resume/page-transfer-resume.component";
import { inject } from "@angular/core";


export const routes: Routes = [
  {
    path: 'token/:token',
    component: PaymentFlowComponent,
    canActivate: [ (route: ActivatedRouteSnapshot) => inject(ParamsGuard).canActivate(route) ]
  },
  {
    path: 'complete',
    component: PageTransferResumeComponent,
  },
  {
    path: 'outschedule',
    component: PageOutScheduleComponent
  },
  {
    path: 'error',
    component: PageErrorGlobalComponent
  },
  {
    path: '**',
    component: PageErrorGlobalComponent
  },
];
